// Document query keys

const scopes = {
  documents: "documents",
  inbox: "inbox",
  ocrFieldMapping: "ocrFieldMapping",
  rxExtraction: "rxExtraction",
  rawOcr: "rawOcr",
};

export const documentKeys = {
  documents: {
    scope: scopes.documents,
    all: () => [scopes.documents] as const,
    forPatient: (patientId: number) => [scopes.documents, { patientId }] as const,
  },
  inbox: {
    scope: scopes.inbox,
    all: () => [scopes.inbox] as const,
    forLocation: (locationId: string) => [scopes.inbox, { locationId }] as const,
  },
  ocrFieldMapping: {
    scope: scopes.ocrFieldMapping,
    all: () => [scopes.ocrFieldMapping] as const,
  },
  rxExtraction: {
    scope: scopes.rxExtraction,
    all: () => [scopes.rxExtraction] as const,
    byDocument: (documentId: string) => [scopes.rxExtraction, { documentId }] as const,
  },
  rawOcr: {
    scope: scopes.rawOcr,
    all: () => [scopes.rawOcr] as const,
    byDocument: (documentId: string) => [scopes.rawOcr, { documentId }] as const,
  },
};
